webpackJsonp(["pipelines"],{

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/async_button.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub__ = __webpack_require__("./pipelines/event_hub.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_loading_icon_vue__ = __webpack_require__("./vue_shared/components/loading_icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_loading_icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__vue_shared_components_loading_icon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_directives_tooltip__ = __webpack_require__("./vue_shared/directives/tooltip.js");

/* eslint-disable no-new, no-alert */





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    endpoint: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    cssClass: {
      type: String,
      required: true
    },
    confirmActionMessage: {
      type: String,
      required: false
    }
  },
  directives: {
    tooltip: __WEBPACK_IMPORTED_MODULE_2__vue_shared_directives_tooltip__["a" /* default */]
  },
  components: {
    loadingIcon: __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_loading_icon_vue___default.a
  },
  data: function data() {
    return {
      isLoading: false
    };
  },

  computed: {
    iconClass: function iconClass() {
      return 'fa fa-' + this.icon;
    },
    buttonClass: function buttonClass() {
      return 'btn ' + this.cssClass;
    }
  },
  methods: {
    onClick: function onClick() {
      if (this.confirmActionMessage && confirm(this.confirmActionMessage)) {
        this.makeRequest();
      } else if (!this.confirmActionMessage) {
        this.makeRequest();
      }
    },
    makeRequest: function makeRequest() {
      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__event_hub__["a" /* default */].$emit('postAction', this.endpoint);
    }
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/empty_state.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_empty_states_icons_pipelines_empty_svg__ = __webpack_require__("../../views/shared/empty_states/icons/_pipelines_empty.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_empty_states_icons_pipelines_empty_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_empty_states_icons_pipelines_empty_svg__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    helpPagePath: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return { pipelinesEmptyStateSVG: __WEBPACK_IMPORTED_MODULE_0_empty_states_icons_pipelines_empty_svg___default.a };
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/error_state.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_empty_states_icons_pipelines_failed_svg__ = __webpack_require__("../../views/shared/empty_states/icons/_pipelines_failed.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_empty_states_icons_pipelines_failed_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_empty_states_icons_pipelines_failed_svg__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return { pipelinesErrorStateSVG: __WEBPACK_IMPORTED_MODULE_0_empty_states_icons_pipelines_failed_svg___default.a };
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/nav_controls.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PipelineNavControls',
  props: {
    newPipelinePath: {
      type: String,
      required: true
    },

    hasCiEnabled: {
      type: Boolean,
      required: true
    },

    helpPagePath: {
      type: String,
      required: true
    },

    ciLintPath: {
      type: String,
      required: true
    },

    canCreatePipeline: {
      type: Boolean,
      required: true
    }
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/navigation_tabs.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PipelineNavigationTabs',
  props: {
    scope: {
      type: String,
      required: true
    },
    count: {
      type: Object,
      required: true
    },
    paths: {
      type: Object,
      required: true
    }
  },
  mounted: function mounted() {
    $(document).trigger('init.scrolling-tabs');
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipeline_url.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_shared_components_user_avatar_user_avatar_link_vue__ = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_link.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_shared_components_user_avatar_user_avatar_link_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__vue_shared_components_user_avatar_user_avatar_link_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_directives_tooltip__ = __webpack_require__("./vue_shared/directives/tooltip.js");




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pipeline: {
      type: Object,
      required: true
    }
  },
  components: {
    userAvatarLink: __WEBPACK_IMPORTED_MODULE_0__vue_shared_components_user_avatar_user_avatar_link_vue___default.a
  },
  directives: {
    tooltip: __WEBPACK_IMPORTED_MODULE_1__vue_shared_directives_tooltip__["a" /* default */]
  },
  computed: {
    user: function user() {
      return this.pipeline.user;
    }
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_pipelines_service__ = __webpack_require__("./pipelines/services/pipelines_service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_pipelines__ = __webpack_require__("./pipelines/mixins/pipelines.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_table_pagination_vue__ = __webpack_require__("./vue_shared/components/table_pagination.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_table_pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__vue_shared_components_table_pagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__navigation_tabs_vue__ = __webpack_require__("./pipelines/components/navigation_tabs.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__navigation_tabs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__navigation_tabs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nav_controls_vue__ = __webpack_require__("./pipelines/components/nav_controls.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nav_controls_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__nav_controls_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    store: {
      type: Object,
      required: true
    }
  },
  components: {
    tablePagination: __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_table_pagination_vue___default.a,
    navigationTabs: __WEBPACK_IMPORTED_MODULE_3__navigation_tabs_vue___default.a,
    navigationControls: __WEBPACK_IMPORTED_MODULE_4__nav_controls_vue___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_pipelines__["a" /* default */]],
  data: function data() {
    var pipelinesData = document.querySelector('#pipelines-list-vue').dataset;

    return {
      endpoint: pipelinesData.endpoint,
      cssClass: pipelinesData.cssClass,
      helpPagePath: pipelinesData.helpPagePath,
      newPipelinePath: pipelinesData.newPipelinePath,
      canCreatePipeline: pipelinesData.canCreatePipeline,
      allPath: pipelinesData.allPath,
      pendingPath: pipelinesData.pendingPath,
      runningPath: pipelinesData.runningPath,
      finishedPath: pipelinesData.finishedPath,
      branchesPath: pipelinesData.branchesPath,
      tagsPath: pipelinesData.tagsPath,
      hasCi: pipelinesData.hasCi,
      ciLintPath: pipelinesData.ciLintPath,
      state: this.store.state,
      apiScope: 'all',
      pagenum: 1
    };
  },

  computed: {
    canCreatePipelineParsed: function canCreatePipelineParsed() {
      return gl.utils.convertPermissionToBoolean(this.canCreatePipeline);
    },
    scope: function scope() {
      var scope = gl.utils.getParameterByName('scope');
      return scope === null ? 'all' : scope;
    },


    /**
    * The empty state should only be rendered when the request is made to fetch all pipelines
    * and none is returned.
    *
    * @return {Boolean}
    */
    shouldRenderEmptyState: function shouldRenderEmptyState() {
      return !this.isLoading && !this.hasError && this.hasMadeRequest && !this.state.pipelines.length && (this.scope === 'all' || this.scope === null);
    },

    /**
     * When a specific scope does not have pipelines we render a message.
     *
     * @return {Boolean}
     */
    shouldRenderNoPipelinesMessage: function shouldRenderNoPipelinesMessage() {
      return !this.isLoading && !this.hasError && !this.state.pipelines.length && this.scope !== 'all' && this.scope !== null;
    },
    shouldRenderTable: function shouldRenderTable() {
      return !this.hasError && !this.isLoading && this.state.pipelines.length;
    },

    /**
    * Pagination should only be rendered when there is more than one page.
    *
    * @return {Boolean}
    */
    shouldRenderPagination: function shouldRenderPagination() {
      return !this.isLoading && this.state.pipelines.length && this.state.pageInfo.total > this.state.pageInfo.perPage;
    },
    hasCiEnabled: function hasCiEnabled() {
      return this.hasCi !== undefined;
    },
    paths: function paths() {
      return {
        allPath: this.allPath,
        pendingPath: this.pendingPath,
        finishedPath: this.finishedPath,
        runningPath: this.runningPath,
        branchesPath: this.branchesPath,
        tagsPath: this.tagsPath
      };
    },
    pageParameter: function pageParameter() {
      return gl.utils.getParameterByName('page') || this.pagenum;
    },
    scopeParameter: function scopeParameter() {
      return gl.utils.getParameterByName('scope') || this.apiScope;
    }
  },
  created: function created() {
    this.service = new __WEBPACK_IMPORTED_MODULE_0__services_pipelines_service__["a" /* default */](this.endpoint);
    this.requestData = { page: this.pageParameter, scope: this.scopeParameter };
  },

  methods: {
    /**
     * Will change the page number and update the URL.
     *
     * @param  {Number} pageNumber desired page to go to.
     */
    change: function change(pageNumber) {
      var param = gl.utils.setParamInURL('page', pageNumber);

      gl.utils.visitUrl(param);
      return param;
    },
    successCallback: function successCallback(resp) {
      var response = {
        headers: resp.headers,
        body: resp.json()
      };

      this.store.storeCount(response.body.count);
      this.store.storePagination(response.headers);
      this.setCommonData(response.body.pipelines);
    }
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_actions.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__flash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_icons_icon_play_svg__ = __webpack_require__("../../views/shared/icons/_icon_play.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_icons_icon_play_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_icons_icon_play_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub__ = __webpack_require__("./pipelines/event_hub.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_shared_components_loading_icon_vue__ = __webpack_require__("./vue_shared/components/loading_icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_shared_components_loading_icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__vue_shared_components_loading_icon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_shared_directives_tooltip__ = __webpack_require__("./vue_shared/directives/tooltip.js");

/* global Flash */






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    actions: {
      type: Array,
      required: true
    }
  },
  directives: {
    tooltip: __WEBPACK_IMPORTED_MODULE_4__vue_shared_directives_tooltip__["a" /* default */]
  },
  components: {
    loadingIcon: __WEBPACK_IMPORTED_MODULE_3__vue_shared_components_loading_icon_vue___default.a
  },
  data: function data() {
    return {
      playIconSvg: __WEBPACK_IMPORTED_MODULE_1_icons_icon_play_svg___default.a,
      isLoading: false
    };
  },

  methods: {
    onClickAction: function onClickAction(endpoint) {
      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_2__event_hub__["a" /* default */].$emit('postAction', endpoint);
    },
    isActionDisabled: function isActionDisabled(action) {
      if (action.playable === undefined) {
        return false;
      }

      return !action.playable;
    }
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_artifacts.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_shared_directives_tooltip__ = __webpack_require__("./vue_shared/directives/tooltip.js");



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    artifacts: {
      type: Array,
      required: true
    }
  },
  directives: {
    tooltip: __WEBPACK_IMPORTED_MODULE_0__vue_shared_directives_tooltip__["a" /* default */]
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_table.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pipelines_table_row_vue__ = __webpack_require__("./pipelines/components/pipelines_table_row.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pipelines_table_row_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pipelines_table_row_vue__);



/**
 * Pipelines Table Component.
 *
 * Given an array of objects, renders a table.
 */
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pipelines: {
      type: Array,
      required: true
    },
    updateGraphDropdown: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    pipelinesTableRowComponent: __WEBPACK_IMPORTED_MODULE_0__pipelines_table_row_vue___default.a
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_table_row.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__async_button_vue__ = __webpack_require__("./pipelines/components/async_button.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__async_button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__async_button_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pipelines_actions_vue__ = __webpack_require__("./pipelines/components/pipelines_actions.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pipelines_actions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pipelines_actions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pipelines_artifacts_vue__ = __webpack_require__("./pipelines/components/pipelines_artifacts.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pipelines_artifacts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pipelines_artifacts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_shared_components_ci_badge_link_vue__ = __webpack_require__("./vue_shared/components/ci_badge_link.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_shared_components_ci_badge_link_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__vue_shared_components_ci_badge_link_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stage_vue__ = __webpack_require__("./pipelines/components/stage.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__stage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pipeline_url_vue__ = __webpack_require__("./pipelines/components/pipeline_url.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pipeline_url_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pipeline_url_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__time_ago_vue__ = __webpack_require__("./pipelines/components/time_ago.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__time_ago_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__time_ago_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vue_shared_components_commit_vue__ = __webpack_require__("./vue_shared/components/commit.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vue_shared_components_commit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__vue_shared_components_commit_vue__);

/* eslint-disable no-param-reassign */









/**
 * Pipeline table row.
 *
 * Given the received object renders a table row in the pipelines' table.
 */
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pipeline: {
      type: Object,
      required: true
    },
    updateGraphDropdown: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    asyncButtonComponent: __WEBPACK_IMPORTED_MODULE_0__async_button_vue___default.a,
    pipelinesActionsComponent: __WEBPACK_IMPORTED_MODULE_1__pipelines_actions_vue___default.a,
    pipelinesArtifactsComponent: __WEBPACK_IMPORTED_MODULE_2__pipelines_artifacts_vue___default.a,
    commitComponent: __WEBPACK_IMPORTED_MODULE_7__vue_shared_components_commit_vue___default.a,
    pipelineStage: __WEBPACK_IMPORTED_MODULE_4__stage_vue___default.a,
    pipelineUrl: __WEBPACK_IMPORTED_MODULE_5__pipeline_url_vue___default.a,
    ciBadge: __WEBPACK_IMPORTED_MODULE_3__vue_shared_components_ci_badge_link_vue___default.a,
    pipelinesTimeago: __WEBPACK_IMPORTED_MODULE_6__time_ago_vue___default.a
  },
  computed: {
    /**
     * If provided, returns the commit tag.
     * Needed to render the commit component column.
     *
     * This field needs a lot of verification, because of different possible cases:
     *
     * 1. person who is an author of a commit might be a GitLab user
     * 2. if person who is an author of a commit is a GitLab user he/she can have a GitLab avatar
     * 3. If GitLab user does not have avatar he/she might have a Gravatar
     * 4. If committer is not a GitLab User he/she can have a Gravatar
     * 5. We do not have consistent API object in this case
     * 6. We should improve API and the code
     *
     * @returns {Object|Undefined}
     */
    commitAuthor: function commitAuthor() {
      var commitAuthorInformation = void 0;

      if (!this.pipeline || !this.pipeline.commit) {
        return null;
      }

      // 1. person who is an author of a commit might be a GitLab user
      if (this.pipeline.commit.author) {
        // 2. if person who is an author of a commit is a GitLab user
        // he/she can have a GitLab avatar
        if (this.pipeline.commit.author.avatar_url) {
          commitAuthorInformation = this.pipeline.commit.author;

          // 3. If GitLab user does not have avatar he/she might have a Gravatar
        } else if (this.pipeline.commit.author_gravatar_url) {
          commitAuthorInformation = Object.assign({}, this.pipeline.commit.author, {
            avatar_url: this.pipeline.commit.author_gravatar_url
          });
        }
        // 4. If committer is not a GitLab User he/she can have a Gravatar
      } else {
        commitAuthorInformation = {
          avatar_url: this.pipeline.commit.author_gravatar_url,
          path: 'mailto:' + this.pipeline.commit.author_email,
          username: this.pipeline.commit.author_name
        };
      }

      return commitAuthorInformation;
    },


    /**
     * If provided, returns the commit tag.
     * Needed to render the commit component column.
     *
     * @returns {String|Undefined}
     */
    commitTag: function commitTag() {
      if (this.pipeline.ref && this.pipeline.ref.tag) {
        return this.pipeline.ref.tag;
      }
      return undefined;
    },


    /**
     * If provided, returns the commit ref.
     * Needed to render the commit component column.
     *
     * Matches `path` prop sent in the API to `ref_url` prop needed
     * in the commit component.
     *
     * @returns {Object|Undefined}
     */
    commitRef: function commitRef() {
      var _this = this;

      if (this.pipeline.ref) {
        return Object.keys(this.pipeline.ref).reduce(function (accumulator, prop) {
          if (prop === 'path') {
            accumulator.ref_url = _this.pipeline.ref[prop];
          } else {
            accumulator[prop] = _this.pipeline.ref[prop];
          }
          return accumulator;
        }, {});
      }

      return undefined;
    },


    /**
     * If provided, returns the commit url.
     * Needed to render the commit component column.
     *
     * @returns {String|Undefined}
     */
    commitUrl: function commitUrl() {
      if (this.pipeline.commit && this.pipeline.commit.commit_path) {
        return this.pipeline.commit.commit_path;
      }
      return undefined;
    },


    /**
     * If provided, returns the commit short sha.
     * Needed to render the commit component column.
     *
     * @returns {String|Undefined}
     */
    commitShortSha: function commitShortSha() {
      if (this.pipeline.commit && this.pipeline.commit.short_id) {
        return this.pipeline.commit.short_id;
      }
      return undefined;
    },


    /**
     * If provided, returns the commit title.
     * Needed to render the commit component column.
     *
     * @returns {String|Undefined}
     */
    commitTitle: function commitTitle() {
      if (this.pipeline.commit && this.pipeline.commit.title) {
        return this.pipeline.commit.title;
      }
      return undefined;
    },


    /**
     * Timeago components expects a number
     *
     * @return {type}  description
     */
    pipelineDuration: function pipelineDuration() {
      if (this.pipeline.details && this.pipeline.details.duration) {
        return this.pipeline.details.duration;
      }

      return 0;
    },


    /**
     * Timeago component expects a String.
     *
     * @return {String}
     */
    pipelineFinishedAt: function pipelineFinishedAt() {
      if (this.pipeline.details && this.pipeline.details.finished_at) {
        return this.pipeline.details.finished_at;
      }

      return '';
    },
    pipelineStatus: function pipelineStatus() {
      if (this.pipeline.details && this.pipeline.details.status) {
        return this.pipeline.details.status;
      }
      return {};
    },
    displayPipelineActions: function displayPipelineActions() {
      return this.pipeline.flags.retryable || this.pipeline.flags.cancelable || this.pipeline.details.manual_actions.length || this.pipeline.details.artifacts.length;
    }
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/stage.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_shared_ci_status_icons__ = __webpack_require__("./vue_shared/ci_status_icons.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_loading_icon_vue__ = __webpack_require__("./vue_shared/components/loading_icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_loading_icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__vue_shared_components_loading_icon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_directives_tooltip__ = __webpack_require__("./vue_shared/directives/tooltip.js");


/**
 * Renders each stage of the pipeline mini graph.
 *
 * Given the provided endpoint will make a request to
 * fetch the dropdown data when the stage is clicked.
 *
 * Request is made inside this component to make it reusable between:
 * 1. Pipelines main table
 * 2. Pipelines table in commit and Merge request views
 * 3. Merge request widget
 * 4. Commit widget
 */

/* global Flash */




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    stage: {
      type: Object,
      required: true
    },

    updateDropdown: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  directives: {
    tooltip: __WEBPACK_IMPORTED_MODULE_2__vue_shared_directives_tooltip__["a" /* default */]
  },

  data: function data() {
    return {
      isLoading: false,
      dropdownContent: ''
    };
  },


  components: {
    loadingIcon: __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_loading_icon_vue___default.a
  },

  updated: function updated() {
    if (this.dropdownContent.length > 0) {
      this.stopDropdownClickPropagation();
    }
  },


  watch: {
    updateDropdown: function updateDropdown() {
      if (this.updateDropdown && this.isDropdownOpen() && !this.isLoading) {
        this.fetchJobs();
      }
    }
  },

  methods: {
    onClickStage: function onClickStage() {
      if (!this.isDropdownOpen()) {
        this.isLoading = true;
        this.fetchJobs();
      }
    },
    fetchJobs: function fetchJobs() {
      var _this = this;

      this.$http.get(this.stage.dropdown_path).then(function (response) {
        _this.dropdownContent = response.json().html;
        _this.isLoading = false;
      }).catch(function () {
        _this.closeDropdown();
        _this.isLoading = false;

        var flash = new Flash('Something went wrong on our end.');
        return flash;
      });
    },


    /**
     * When the user right clicks or cmd/ctrl + click in the job name
     * the dropdown should not be closed and the link should open in another tab,
     * so we stop propagation of the click event inside the dropdown.
     *
     * Since this component is rendered multiple times per page we need to guarantee we only
     * target the click event of this component.
     */
    stopDropdownClickPropagation: function stopDropdownClickPropagation() {
      $(this.$el.querySelectorAll('.js-builds-dropdown-list a.mini-pipeline-graph-dropdown-item')).on('click', function (e) {
        e.stopPropagation();
      });
    },
    closeDropdown: function closeDropdown() {
      if (this.isDropdownOpen()) {
        $(this.$refs.dropdown).dropdown('toggle');
      }
    },
    isDropdownOpen: function isDropdownOpen() {
      return this.$el.classList.contains('open');
    }
  },

  computed: {
    dropdownClass: function dropdownClass() {
      return this.dropdownContent.length > 0 ? 'js-builds-dropdown-container' : 'js-builds-dropdown-loading';
    },
    triggerButtonClass: function triggerButtonClass() {
      return 'ci-status-icon-' + this.stage.status.group;
    },
    svgIcon: function svgIcon() {
      return __WEBPACK_IMPORTED_MODULE_0__vue_shared_ci_status_icons__["b" /* borderlessStatusIconEntityMap */][this.stage.status.icon];
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/time_ago.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icons_icon_timer_svg__ = __webpack_require__("../../views/shared/icons/_icon_timer.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icons_icon_timer_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_icons_icon_timer_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_datetime_utility__ = __webpack_require__("./lib/utils/datetime_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_directives_tooltip__ = __webpack_require__("./vue_shared/directives/tooltip.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_shared_mixins_timeago__ = __webpack_require__("./vue_shared/mixins/timeago.js");






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    finishedTime: {
      type: String,
      required: true
    },
    duration: {
      type: Number,
      required: true
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__vue_shared_mixins_timeago__["a" /* default */]],
  directives: {
    tooltip: __WEBPACK_IMPORTED_MODULE_2__vue_shared_directives_tooltip__["a" /* default */]
  },
  data: function data() {
    return {
      iconTimerSvg: __WEBPACK_IMPORTED_MODULE_0_icons_icon_timer_svg___default.a
    };
  },

  computed: {
    hasDuration: function hasDuration() {
      return this.duration > 0;
    },
    hasFinishedTime: function hasFinishedTime() {
      return this.finishedTime !== '';
    },
    durationFormated: function durationFormated() {
      var date = new Date(this.duration * 1000);

      var hh = date.getUTCHours();
      var mm = date.getUTCMinutes();
      var ss = date.getSeconds();

      // left pad
      if (hh < 10) {
        hh = '0' + hh;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      if (ss < 10) {
        ss = '0' + ss;
      }

      return hh + ':' + mm + ':' + ss;
    }
  }
});

/***/ }),

/***/ "../../../node_modules/visibilityjs/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../../../node_modules/visibilityjs/lib/visibility.timers.js")


/***/ }),

/***/ "../../../node_modules/visibilityjs/lib/visibility.core.js":
/***/ (function(module, exports) {

;(function (global) {
    "use strict";

    var lastId = -1;

    // Visibility.js allow you to know, that your web page is in the background
    // tab and thus not visible to the user. This library is wrap under
    // Page Visibility API. It fix problems with different vendor prefixes and
    // add high-level useful functions.
    var self = {

        // Call callback only when page become to visible for user or
        // call it now if page is visible now or Page Visibility API
        // doesn’t supported.
        //
        // Return false if API isn’t supported, true if page is already visible
        // or listener ID (you can use it in `unbind` method) if page isn’t
        // visible now.
        //
        //   Visibility.onVisible(function () {
        //       startIntroAnimation();
        //   });
        onVisible: function (callback) {
            var support = self.isSupported();
            if ( !support || !self.hidden() ) {
                callback();
                return support;
            }

            var listener = self.change(function (e, state) {
                if ( !self.hidden() ) {
                    self.unbind(listener);
                    callback();
                }
            });
            return listener;
        },

        // Call callback when visibility will be changed. First argument for
        // callback will be original event object, second will be visibility
        // state name.
        //
        // Return listener ID to unbind listener by `unbind` method.
        //
        // If Page Visibility API doesn’t supported method will be return false
        // and callback never will be called.
        //
        //   Visibility.change(function(e, state) {
        //       Statistics.visibilityChange(state);
        //   });
        //
        // It is just proxy to `visibilitychange` event, but use vendor prefix.
        change: function (callback) {
            if ( !self.isSupported() ) {
                return false;
            }
            lastId += 1;
            var number = lastId;
            self._callbacks[number] = callback;
            self._listen();
            return number;
        },

        // Remove `change` listener by it ID.
        //
        //   var id = Visibility.change(function(e, state) {
        //       firstChangeCallback();
        //       Visibility.unbind(id);
        //   });
        unbind: function (id) {
            delete self._callbacks[id];
        },

        // Call `callback` in any state, expect “prerender”. If current state
        // is “prerender” it will wait until state will be changed.
        // If Page Visibility API doesn’t supported, it will call `callback`
        // immediately.
        //
        // Return false if API isn’t supported, true if page is already after
        // prerendering or listener ID (you can use it in `unbind` method)
        // if page is prerended now.
        //
        //   Visibility.afterPrerendering(function () {
        //       Statistics.countVisitor();
        //   });
        afterPrerendering: function (callback) {
            var support   = self.isSupported();
            var prerender = 'prerender';

            if ( !support || prerender != self.state() ) {
                callback();
                return support;
            }

            var listener = self.change(function (e, state) {
                if ( prerender != state ) {
                    self.unbind(listener);
                    callback();
                }
            });
            return listener;
        },

        // Return true if page now isn’t visible to user.
        //
        //   if ( !Visibility.hidden() ) {
        //       VideoPlayer.play();
        //   }
        //
        // It is just proxy to `document.hidden`, but use vendor prefix.
        hidden: function () {
            return !!(self._doc.hidden || self._doc.webkitHidden);
        },

        // Return visibility state: 'visible', 'hidden' or 'prerender'.
        //
        //   if ( 'prerender' == Visibility.state() ) {
        //       Statistics.pageIsPrerendering();
        //   }
        //
        // Don’t use `Visibility.state()` to detect, is page visible, because
        // visibility states can extend in next API versions.
        // Use more simpler and general `Visibility.hidden()` for this cases.
        //
        // It is just proxy to `document.visibilityState`, but use
        // vendor prefix.
        state: function () {
            return self._doc.visibilityState       ||
                   self._doc.webkitVisibilityState ||
                   'visible';
        },

        // Return true if browser support Page Visibility API.
        //
        //   if ( Visibility.isSupported() ) {
        //       Statistics.startTrackingVisibility();
        //       Visibility.change(function(e, state)) {
        //           Statistics.trackVisibility(state);
        //       });
        //   }
        isSupported: function () {
            return !!(self._doc.visibilityState ||
                      self._doc.webkitVisibilityState);
        },

        // Link to document object to change it in tests.
        _doc: document || {},

        // Callbacks from `change` method, that wait visibility changes.
        _callbacks: { },

        // Listener for `visibilitychange` event.
        _change: function(event) {
            var state = self.state();

            for ( var i in self._callbacks ) {
                self._callbacks[i].call(self._doc, event, state);
            }
        },

        // Set listener for `visibilitychange` event.
        _listen: function () {
            if ( self._init ) {
                return;
            }

            var event = 'visibilitychange';
            if ( self._doc.webkitVisibilityState ) {
                event = 'webkit' + event;
            }

            var listener = function () {
                self._change.apply(self, arguments);
            };
            if ( self._doc.addEventListener ) {
                self._doc.addEventListener(event, listener);
            } else {
                self._doc.attachEvent(event, listener);
            }
            self._init = true;
        }

    };

    if ( typeof(module) != 'undefined' && module.exports ) {
        module.exports = self;
    } else {
        global.Visibility = self;
    }

})(this);


/***/ }),

/***/ "../../../node_modules/visibilityjs/lib/visibility.timers.js":
/***/ (function(module, exports, __webpack_require__) {

;(function (window) {
    "use strict";

    var lastTimer = -1;

    var install = function (Visibility) {

        // Run callback every `interval` milliseconds if page is visible and
        // every `hiddenInterval` milliseconds if page is hidden.
        //
        //   Visibility.every(60 * 1000, 5 * 60 * 1000, function () {
        //       checkNewMails();
        //   });
        //
        // You can skip `hiddenInterval` and callback will be called only if
        // page is visible.
        //
        //   Visibility.every(1000, function () {
        //       updateCountdown();
        //   });
        //
        // It is analog of `setInterval(callback, interval)` but use visibility
        // state.
        //
        // It return timer ID, that you can use in `Visibility.stop(id)` to stop
        // timer (`clearInterval` analog).
        // Warning: timer ID is different from interval ID from `setInterval`,
        // so don’t use it in `clearInterval`.
        //
        // On change state from hidden to visible timers will be execute.
        Visibility.every = function (interval, hiddenInterval, callback) {
            Visibility._time();

            if ( !callback ) {
                callback = hiddenInterval;
                hiddenInterval = null;
            }

            lastTimer += 1;
            var number = lastTimer;

            Visibility._timers[number] = {
                visible:  interval,
                hidden:   hiddenInterval,
                callback: callback
            };
            Visibility._run(number, false);

            if ( Visibility.isSupported() ) {
                Visibility._listen();
            }
            return number;
        };

        // Stop timer from `every` method by it ID (`every` method return it).
        //
        //   slideshow = Visibility.every(5 * 1000, function () {
        //       changeSlide();
        //   });
        //   $('.stopSlideshow').click(function () {
        //       Visibility.stop(slideshow);
        //   });
        Visibility.stop = function(id) {
            if ( !Visibility._timers[id] ) {
                return false;
            }
            Visibility._stop(id);
            delete Visibility._timers[id];
            return true;
        };

        // Callbacks and intervals added by `every` method.
        Visibility._timers = { };

        // Initialize variables on page loading.
        Visibility._time = function () {
            if ( Visibility._timed ) {
                return;
            }
            Visibility._timed     = true;
            Visibility._wasHidden = Visibility.hidden();

            Visibility.change(function () {
                Visibility._stopRun();
                Visibility._wasHidden = Visibility.hidden();
            });
        };

        // Try to run timer from every method by it’s ID. It will be use
        // `interval` or `hiddenInterval` depending on visibility state.
        // If page is hidden and `hiddenInterval` is null,
        // it will not run timer.
        //
        // Argument `runNow` say, that timers must be execute now too.
        Visibility._run = function (id, runNow) {
            var interval,
                timer = Visibility._timers[id];

            if ( Visibility.hidden() ) {
                if ( null === timer.hidden ) {
                    return;
                }
                interval = timer.hidden;
            } else {
                interval = timer.visible;
            }

            var runner = function () {
                timer.last = new Date();
                timer.callback.call(window);
            }

            if ( runNow ) {
                var now  = new Date();
                var last = now - timer.last ;

                if ( interval > last ) {
                    timer.delay = setTimeout(function () {
                        timer.id = setInterval(runner, interval);
                        runner();
                    }, interval - last);
                } else {
                    timer.id = setInterval(runner, interval);
                    runner();
                }

            } else {
              timer.id = setInterval(runner, interval);
            }
        };

        // Stop timer from `every` method by it’s ID.
        Visibility._stop = function (id) {
            var timer = Visibility._timers[id];
            clearInterval(timer.id);
            clearTimeout(timer.delay);
            delete timer.id;
            delete timer.delay;
        };

        // Listener for `visibilitychange` event.
        Visibility._stopRun = function (event) {
            var isHidden  = Visibility.hidden(),
                wasHidden = Visibility._wasHidden;

            if ( (isHidden && !wasHidden) || (!isHidden && wasHidden) ) {
                for ( var i in Visibility._timers ) {
                    Visibility._stop(i);
                    Visibility._run(i, !isHidden);
                }
            }
        };

        return Visibility;
    }

    if ( typeof(module) != 'undefined' && module.exports ) {
        module.exports = install(__webpack_require__("../../../node_modules/visibilityjs/lib/visibility.core.js"));
    } else {
        install(window.Visibility)
    }

})(window);


/***/ }),

/***/ "../../../node_modules/vue-loader/lib/component-normalizer.js":
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-06d5852e\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/async_button.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    class: _vm.buttonClass,
    attrs: {
      "type": "button",
      "title": _vm.title,
      "aria-label": _vm.title,
      "data-container": "body",
      "data-placement": "top",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('i', {
    class: _vm.iconClass,
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('loading-icon') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-2528e465\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/navigation_tabs.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav-links scrolling-tabs"
  }, [_c('li', {
    staticClass: "js-pipelines-tab-all",
    class: {
      active: _vm.scope === 'all'
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.paths.allPath
    }
  }, [_vm._v("\n      All\n      "), _c('span', {
    staticClass: "badge js-totalbuilds-count"
  }, [_vm._v("\n        " + _vm._s(_vm.count.all) + "\n      ")])])]), _vm._v(" "), _c('li', {
    staticClass: "js-pipelines-tab-pending",
    class: {
      active: _vm.scope === 'pending'
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.paths.pendingPath
    }
  }, [_vm._v("\n      Pending\n      "), _c('span', {
    staticClass: "badge"
  }, [_vm._v("\n        " + _vm._s(_vm.count.pending) + "\n      ")])])]), _vm._v(" "), _c('li', {
    staticClass: "js-pipelines-tab-running",
    class: {
      active: _vm.scope === 'running'
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.paths.runningPath
    }
  }, [_vm._v("\n      Running\n      "), _c('span', {
    staticClass: "badge"
  }, [_vm._v("\n        " + _vm._s(_vm.count.running) + "\n      ")])])]), _vm._v(" "), _c('li', {
    staticClass: "js-pipelines-tab-finished",
    class: {
      active: _vm.scope === 'finished'
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.paths.finishedPath
    }
  }, [_vm._v("\n      Finished\n      "), _c('span', {
    staticClass: "badge"
  }, [_vm._v("\n        " + _vm._s(_vm.count.finished) + "\n      ")])])]), _vm._v(" "), _c('li', {
    staticClass: "js-pipelines-tab-branches",
    class: {
      active: _vm.scope === 'branches'
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.paths.branchesPath
    }
  }, [_vm._v("Branches")])]), _vm._v(" "), _c('li', {
    staticClass: "js-pipelines-tab-tags",
    class: {
      active: _vm.scope === 'tags'
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.paths.tagsPath
    }
  }, [_vm._v("Tags")])])])
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-2dea8a94\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/error_state.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row empty-state js-pipelines-error-state"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "svg-content",
    domProps: {
      "innerHTML": _vm._s(_vm.pipelinesErrorStateSVG)
    }
  })]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('div', {
    staticClass: "text-content"
  }, [_c('h4', [_vm._v("The API failed to fetch the pipelines.")])])])
}]}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-3f0b4b1a\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/stage.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    staticClass: "mini-pipeline-graph-dropdown-toggle js-builds-dropdown-button",
    class: _vm.triggerButtonClass,
    attrs: {
      "title": _vm.stage.title,
      "data-placement": "top",
      "data-toggle": "dropdown",
      "type": "button",
      "id": "stageDropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "click": _vm.onClickStage
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true",
      "aria-label": _vm.stage.title
    },
    domProps: {
      "innerHTML": _vm._s(_vm.svgIcon)
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu mini-pipeline-graph-dropdown-menu js-builds-dropdown-container",
    attrs: {
      "aria-labelledby": "stageDropdown"
    }
  }, [_c('li', {
    staticClass: "js-builds-dropdown-list scrollable-menu",
    class: _vm.dropdownClass
  }, [(_vm.isLoading) ? _c('loading-icon') : _c('ul', {
    domProps: {
      "innerHTML": _vm._s(_vm.dropdownContent)
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-492e488a\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/empty_state.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row empty-state js-empty-state"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "svg-content",
    domProps: {
      "innerHTML": _vm._s(_vm.pipelinesEmptyStateSVG)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('div', {
    staticClass: "text-content"
  }, [_c('h4', [_vm._v("Build with confidence")]), _vm._v(" "), _c('p', [_vm._v("\n        Continous Integration can help catch bugs by running your tests automatically,\n        while Continuous Deployment can help you deliver code to your product environment.\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-info",
    attrs: {
      "href": _vm.helpPagePath
    }
  }, [_vm._v("\n        Get started with Pipelines\n      ")])])])])
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-51860a3c\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_table.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ci-table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.pipelines), function(model) {
    return _c('pipelines-table-row-component', {
      key: model.id,
      attrs: {
        "pipeline": model,
        "update-graph-dropdown": _vm.updateGraphDropdown
      }
    })
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gl-responsive-table-row table-row-header",
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    staticClass: "table-section section-10 js-pipeline-status pipeline-status",
    attrs: {
      "role": "rowheader"
    }
  }, [_vm._v("\n      Status\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "table-section section-15 js-pipeline-info pipeline-info",
    attrs: {
      "role": "rowheader"
    }
  }, [_vm._v("\n      Pipeline\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "table-section section-25 js-pipeline-commit pipeline-commit",
    attrs: {
      "role": "rowheader"
    }
  }, [_vm._v("\n      Commit\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "table-section section-15 js-pipeline-stages pipeline-stages",
    attrs: {
      "role": "rowheader"
    }
  }, [_vm._v("\n      Stages\n    ")])])
}]}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-57efd6e6\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipeline_url.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-section section-15 hidden-xs hidden-sm"
  }, [_c('a', {
    staticClass: "js-pipeline-url-link",
    attrs: {
      "href": _vm.pipeline.path
    }
  }, [_c('span', {
    staticClass: "pipeline-id"
  }, [_vm._v("#" + _vm._s(_vm.pipeline.id))])]), _vm._v(" "), _c('span', [_vm._v("by")]), _vm._v(" "), (_vm.user) ? _c('user-avatar-link', {
    staticClass: "js-pipeline-url-user",
    attrs: {
      "link-href": _vm.pipeline.user.path,
      "img-src": _vm.pipeline.user.avatar_url,
      "tooltip-text": _vm.pipeline.user.name
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.user) ? _c('span', {
    staticClass: "js-pipeline-url-api api"
  }, [_vm._v("\n    API\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "label-container"
  }, [(_vm.pipeline.flags.latest) ? _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    staticClass: "js-pipeline-url-latest label label-success",
    attrs: {
      "title": "Latest pipeline for this branch"
    }
  }, [_vm._v("\n      latest\n    ")]) : _vm._e(), _vm._v(" "), (_vm.pipeline.flags.yaml_errors) ? _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    staticClass: "js-pipeline-url-yaml label label-danger",
    attrs: {
      "title": _vm.pipeline.yaml_errors
    }
  }, [_vm._v("\n      yaml invalid\n    ")]) : _vm._e(), _vm._v(" "), (_vm.pipeline.flags.stuck) ? _c('span', {
    staticClass: "js-pipeline-url-stuck label label-warning"
  }, [_vm._v("\n      stuck\n    ")]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-5cb4e2a6\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.cssClass
  }, [(!_vm.isLoading && !_vm.shouldRenderEmptyState) ? _c('div', {
    staticClass: "top-area scrolling-tabs-container inner-page-scroll-tabs"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('navigation-tabs', {
    attrs: {
      "scope": _vm.scope,
      "count": _vm.state.count,
      "paths": _vm.paths
    }
  }), _vm._v(" "), _c('navigation-controls', {
    attrs: {
      "new-pipeline-path": _vm.newPipelinePath,
      "has-ci-enabled": _vm.hasCiEnabled,
      "help-page-path": _vm.helpPagePath,
      "ciLintPath": _vm.ciLintPath,
      "can-create-pipeline": _vm.canCreatePipelineParsed
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-list pipelines"
  }, [(_vm.isLoading) ? _c('loading-icon', {
    attrs: {
      "label": "Loading Pipelines",
      "size": "3"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shouldRenderEmptyState) ? _c('empty-state', {
    attrs: {
      "help-page-path": _vm.helpPagePath
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shouldRenderErrorState) ? _c('error-state') : _vm._e(), _vm._v(" "), (_vm.shouldRenderNoPipelinesMessage) ? _c('div', {
    staticClass: "blank-state blank-state-no-icon"
  }, [_c('h2', {
    staticClass: "blank-state-title js-blank-state-title"
  }, [_vm._v("No pipelines to show.")])]) : _vm._e(), _vm._v(" "), (_vm.shouldRenderTable) ? _c('div', {
    staticClass: "table-holder"
  }, [_c('pipelines-table-component', {
    attrs: {
      "pipelines": _vm.state.pipelines,
      "update-graph-dropdown": _vm.updateGraphDropdown
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.shouldRenderPagination) ? _c('table-pagination', {
    attrs: {
      "change": _vm.change,
      "pageInfo": _vm.state.pageInfo
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fade-left"
  }, [_c('i', {
    staticClass: "fa fa-angle-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fade-right"
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-5eb08234\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/nav_controls.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-controls"
  }, [(_vm.canCreatePipeline) ? _c('a', {
    staticClass: "btn btn-create",
    attrs: {
      "href": _vm.newPipelinePath
    }
  }, [_vm._v("\n    Run Pipeline\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.hasCiEnabled) ? _c('a', {
    staticClass: "btn btn-info",
    attrs: {
      "href": _vm.helpPagePath
    }
  }, [_vm._v("\n    Get started with Pipelines\n  ")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": _vm.ciLintPath
    }
  }, [_vm._v("\n    CI Lint\n  ")])])
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-709158ab\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/time_ago.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-section section-15 pipelines-time-ago"
  }, [_c('div', {
    staticClass: "table-mobile-header",
    attrs: {
      "role": "rowheader"
    }
  }, [_vm._v("\n      Duration\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "table-mobile-content"
  }, [(_vm.hasDuration) ? _c('p', {
    staticClass: "duration"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.iconTimerSvg)
    }
  }), _vm._v("\n        " + _vm._s(_vm.durationFormated) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.hasFinishedTime) ? _c('p', {
    staticClass: "finished-at hidden-xs hidden-sm"
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('time', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    attrs: {
      "data-placement": "top",
      "data-container": "body",
      "title": _vm.tooltipTitle(_vm.finishedTime)
    }
  }, [_vm._v("\n          " + _vm._s(_vm.timeFormated(_vm.finishedTime)) + "\n        ")])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-713a66cf\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_artifacts.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    staticClass: "dropdown-toggle btn btn-default build-artifacts js-pipeline-dropdown-download",
    attrs: {
      "title": "Artifacts",
      "data-placement": "top",
      "data-toggle": "dropdown",
      "aria-label": "Artifacts"
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-align-right"
  }, _vm._l((_vm.artifacts), function(artifact) {
    return _c('li', [_c('a', {
      attrs: {
        "rel": "nofollow",
        "download": "",
        "href": artifact.path
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Download " + _vm._s(artifact.name) + " artifacts")])])])
  }))])
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-97d30852\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_table_row.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "commit gl-responsive-table-row"
  }, [_c('div', {
    staticClass: "table-section section-10 commit-link"
  }, [_c('div', {
    staticClass: "table-mobile-header",
    attrs: {
      "role": "rowheader"
    }
  }, [_vm._v("\n      Status\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "table-mobile-content"
  }, [_c('ci-badge', {
    attrs: {
      "status": _vm.pipelineStatus
    }
  })], 1)]), _vm._v(" "), _c('pipeline-url', {
    attrs: {
      "pipeline": _vm.pipeline
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-section section-25"
  }, [_c('div', {
    staticClass: "table-mobile-header",
    attrs: {
      "role": "rowheader"
    }
  }, [_vm._v("\n      Commit\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "table-mobile-content"
  }, [_c('commit-component', {
    attrs: {
      "tag": _vm.commitTag,
      "commit-ref": _vm.commitRef,
      "commit-url": _vm.commitUrl,
      "short-sha": _vm.commitShortSha,
      "title": _vm.commitTitle,
      "author": _vm.commitAuthor
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-section section-wrap section-15 stage-cell"
  }, [_c('div', {
    staticClass: "table-mobile-header",
    attrs: {
      "role": "rowheader"
    }
  }, [_vm._v("\n      Stages\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "table-mobile-content"
  }, _vm._l((_vm.pipeline.details.stages), function(stage) {
    return (_vm.pipeline.details.stages.length > 0) ? _c('div', {
      staticClass: "stage-container dropdown js-mini-pipeline-graph"
    }, [_c('pipeline-stage', {
      attrs: {
        "stage": stage,
        "update-dropdown": _vm.updateGraphDropdown
      }
    })], 1) : _vm._e()
  }))]), _vm._v(" "), _c('pipelines-timeago', {
    attrs: {
      "duration": _vm.pipelineDuration,
      "finished-time": _vm.pipelineFinishedAt
    }
  }), _vm._v(" "), (_vm.displayPipelineActions) ? _c('div', {
    staticClass: "table-section section-20 table-button-footer pipeline-actions"
  }, [_c('div', {
    staticClass: "btn-group table-action-buttons"
  }, [(_vm.pipeline.details.manual_actions.length) ? _c('pipelines-actions-component', {
    attrs: {
      "actions": _vm.pipeline.details.manual_actions
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pipeline.details.artifacts.length) ? _c('pipelines-artifacts-component', {
    staticClass: "hidden-xs hidden-sm",
    attrs: {
      "artifacts": _vm.pipeline.details.artifacts
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pipeline.flags.retryable) ? _c('async-button-component', {
    attrs: {
      "endpoint": _vm.pipeline.retry_path,
      "css-class": "js-pipelines-retry-button btn-default btn-retry",
      "title": "Retry",
      "icon": "repeat"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pipeline.flags.cancelable) ? _c('async-button-component', {
    attrs: {
      "endpoint": _vm.pipeline.cancel_path,
      "css-class": "js-pipelines-cancel-button btn-remove",
      "title": "Cancel",
      "icon": "remove",
      "confirm-action-message": "Are you sure you want to cancel this pipeline?"
    }
  }) : _vm._e()], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-d246eb2a\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_actions.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    staticClass: "dropdown-new btn btn-default js-pipeline-dropdown-manual-actions",
    attrs: {
      "type": "button",
      "title": "Manual job",
      "data-toggle": "dropdown",
      "data-placement": "top",
      "aria-label": "Manual job",
      "disabled": _vm.isLoading
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.playIconSvg)
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('loading-icon') : _vm._e()], 1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-align-right"
  }, _vm._l((_vm.actions), function(action) {
    return _c('li', [_c('button', {
      staticClass: "js-pipeline-action-link no-btn btn",
      class: {
        disabled: _vm.isActionDisabled(action)
      },
      attrs: {
        "type": "button",
        "disabled": _vm.isActionDisabled(action)
      },
      on: {
        "click": function($event) {
          _vm.onClickAction(action.path)
        }
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.playIconSvg)
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(action.name))])])])
  }))])
},staticRenderFns: []}

/***/ }),

/***/ "../../views/shared/empty_states/icons/_pipelines_empty.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 150\"><g fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(0 102)\"><g fill=\"#e5e5e5\"><rect width=\"74\" height=\"4\" x=\"34\" y=\"21\" opacity=\".5\" rx=\"2\"/><path d=\"m152 23c0-1.105.887-2 1.998-2h4c1.104 0 1.998.888 1.998 2 0 1.105-.887 2-1.998 2h-4c-1.104 0-1.998-.888-1.998-2m14 0c0-1.105.887-2 1.998-2h4c1.104 0 1.998.888 1.998 2 0 1.105-.887 2-1.998 2h-4c-1.104 0-1.998-.888-1.998-2m14 0c0-1.105.887-2 1.998-2h4c1.104 0 1.998.888 1.998 2 0 1.105-.887 2-1.998 2h-4c-1.104 0-1.998-.888-1.998-2m14 0c0-1.105.887-2 1.998-2h4c1.104 0 1.998.888 1.998 2 0 1.105-.887 2-1.998 2h-4c-1.104 0-1.998-.888-1.998-2m14 0c0-1.105.887-2 1.998-2h4c1.104 0 1.998.888 1.998 2 0 1.105-.887 2-1.998 2h-4c-1.104 0-1.998-.888-1.998-2\"/></g><g fill=\"#31af64\" transform=\"translate(0 4)\"><path fill-rule=\"nonzero\" d=\"m19 38c-10.493 0-19-8.507-19-19 0-10.493 8.507-19 19-19 10.493 0 19 8.507 19 19 0 10.493-8.507 19-19 19m0-4c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15\"/><path d=\"m17.07 21.02l-2.829-2.829c-.786-.786-2.047-.781-2.828 0-.786.786-.781 2.047 0 2.828l4.243 4.243c.392.392.902.587 1.412.588.512.002 1.021-.193 1.41-.582l7.79-7.79c.777-.777.775-2.042-.006-2.823-.786-.786-2.045-.784-2.823-.006l-6.37 6.37\"/></g><g fill=\"#e52c5a\" transform=\"translate(102)\"><path fill-rule=\"nonzero\" d=\"m24 47.5c-12.979 0-23.5-10.521-23.5-23.5 0-12.979 10.521-23.5 23.5-23.5 12.979 0 23.5 10.521 23.5 23.5 0 12.979-10.521 23.5-23.5 23.5m0-5c10.217 0 18.5-8.283 18.5-18.5 0-10.217-8.283-18.5-18.5-18.5-10.217 0-18.5 8.283-18.5 18.5 0 10.217 8.283 18.5 18.5 18.5\"/><path d=\"m28.24 24l2.833-2.833c1.167-1.167 1.167-3.067-.004-4.239-1.169-1.169-3.069-1.173-4.239-.004l-2.833 2.833-2.833-2.833c-1.167-1.167-3.067-1.167-4.239.004-1.169 1.169-1.173 3.069-.004 4.239l2.833 2.833-2.833 2.833c-1.167 1.167-1.167 3.067.004 4.239 1.169 1.169 3.069 1.173 4.239.004l2.833-2.833 2.833 2.833c1.167 1.167 3.067 1.167 4.239-.004 1.169-1.169 1.173-3.069.004-4.239l-2.833-2.833\"/></g><path fill=\"#e5e5e5\" fill-rule=\"nonzero\" d=\"m236 37c-7.732 0-14-6.268-14-14 0-7.732 6.268-14 14-14 7.732 0 14 6.268 14 14 0 7.732-6.268 14-14 14m0-4c5.523 0 10-4.477 10-10 0-5.523-4.477-10-10-10-5.523 0-10 4.477-10 10 0 5.523 4.477 10 10 10\"/></g><g transform=\"translate(73 4)\"><path stroke=\"#e5e5e5\" stroke-width=\"4\" d=\"m64.82 76h33.18c4.419 0 8-3.579 8-7.99v-60.02c0-4.413-3.583-7.99-8-7.99h-89.991c-4.419 0-8 3.579-8 7.99v60.02c0 4.413 3.583 7.99 8 7.99h31.935l9.263 9.855c1.725 1.835 4.631 1.833 6.354 0l9.263-9.855\"/><rect width=\"18\" height=\"6\" x=\"11\" y=\"19\" fill=\"#fc8a51\" rx=\"3\"/><rect width=\"18\" height=\"6\" x=\"35\" y=\"35\" fill=\"#e52c5a\" rx=\"3\"/><rect width=\"18\" height=\"6\" x=\"29\" y=\"51\" fill=\"#e5e5e5\" rx=\"3\"/><rect width=\"12\" height=\"6\" x=\"35\" y=\"19\" fill=\"#fde5d8\" rx=\"3\"/><rect width=\"12\" height=\"6\" x=\"53\" y=\"51\" fill=\"#e52c5a\" rx=\"3\"/><rect width=\"12\" height=\"6\" x=\"11\" y=\"51\" fill=\"#b5a7dd\" rx=\"3\"/><rect width=\"18\" height=\"6\" x=\"77\" y=\"19\" fill=\"#fc8a51\" rx=\"3\"/><rect width=\"18\" height=\"6\" x=\"11\" y=\"35\" fill=\"#fde5d8\" rx=\"3\"/><rect width=\"6\" height=\"6\" x=\"53\" y=\"19\" fill=\"#e52c5a\" rx=\"3\"/><g fill=\"#fde5d8\"><rect width=\"6\" height=\"6\" x=\"65\" y=\"19\" rx=\"3\"/><rect width=\"6\" height=\"6\" x=\"71\" y=\"35\" rx=\"3\"/></g><rect width=\"6\" height=\"6\" x=\"59\" y=\"35\" fill=\"#e52c5a\" rx=\"3\"/></g><path fill=\"#6b4fbb\" fill-rule=\"nonzero\" d=\"m28.02 67.48c-15.927-2.825-28.02-16.738-28.02-33.476 0-18.778 15.222-34 34-34 18.778 0 34 15.222 34 34 0 16.738-12.1 30.652-28.02 33.476.015.173.023.347.023.524v21.999c0 3.314-2.693 6-6 6-3.314 0-6-2.682-6-6v-21.999c0-.177.008-.351.023-.524m5.977-7.476c14.359 0 26-11.641 26-26 0-14.359-11.641-26-26-26-14.359 0-26 11.641-26 26 0 14.359 11.641 26 26 26\" transform=\"matrix(.70711-.70711.70711.70711 84.34 49.5)\"/></g></svg>\n"

/***/ }),

/***/ "../../views/shared/empty_states/icons/_pipelines_failed.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 446 249\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><path id=\"0\" d=\"m260.03 114h23.972v-.013c19.972-.53 36-16.887 36-36.987 0-20.435-16.565-37-37-37-.993 0-1.977.039-2.95.116-4.95-14.605-18.773-25.12-35.05-25.12-5.464 0-10.652 1.185-15.32 3.311-6.649-9.841-17.909-16.311-30.68-16.311-20.435 0-37 16.565-37 37 0 .701.019 1.397.058 2.088-16.11 3.999-28.06 18.561-28.06 35.912 0 20.435 16.565 37 37 37 .324 0 .646-.004.968-.012\"/><ellipse id=\"2\" cx=\"41\" cy=\"41\" rx=\"41\" ry=\"41\"/><mask id=\"1\" width=\"186\" height=\"112\" x=\"0\" y=\"0\" fill=\"#fff\"><use xlink:href=\"#0\"/></mask><mask id=\"3\" width=\"82\" height=\"82\" x=\"0\" y=\"0\" fill=\"#fff\"><use xlink:href=\"#2\"/></mask></defs><g fill=\"none\" fill-rule=\"evenodd\"><g transform=\"matrix(.86603.5-.5.86603 228.11 137.43)\"><path stroke=\"#b5a7dd\" stroke-width=\"4\" d=\"m.445.161c15.89 10.636 34.998 16.839 55.55 16.839\"/><g transform=\"translate(56 4)\"><path fill=\"#fb722e\" d=\"m16 8c0-1.105.902-2 2.01-2h7.983c1.109 0 2.01.888 2.01 2 0 1.105-.902 2-2.01 2h-7.983c-1.109 0-2.01-.888-2.01-2m0 10c0-1.105.902-2 2.01-2h7.983c1.109 0 2.01.888 2.01 2 0 1.105-.902 2-2.01 2h-7.983c-1.109 0-2.01-.888-2.01-2\"/><path fill=\"#fde5d8\" fill-rule=\"nonzero\" d=\"m4 22h6c3.315 0 6-2.685 6-5.997v-6.01c0-3.315-2.684-5.997-6-5.997h-6v18m-4-18.992c0-1.661 1.343-3.01 2.994-3.01h7.01c5.523 0 10 4.47 10 9.997v6.01c0 5.521-4.476 9.997-10 9.997h-7.01c-1.654 0-2.994-1.343-2.994-3.01v-19.984\"/></g></g><g fill-rule=\"nonzero\" transform=\"translate(257)\"><path fill=\"#e5e5e5\" d=\"m3.597 18.747c5.611-9.09 15.519-14.747 26.403-14.747 17.12 0 31 13.879 31 31 0 7.02-2.34 13.685-6.58 19.1l3.149 2.466c4.786-6.111 7.431-13.639 7.431-21.565 0-19.33-15.67-35-35-35-12.286 0-23.476 6.384-29.808 16.647l3.404 2.1\"/><g transform=\"matrix(.96593.25882-.25882.96593 15.98 9.578)\"><path fill=\"#b5a7dd\" d=\"m12.426 11.592l-2.142 1.768-3.664-2.116c-.186-.107-.43-.042-.543.154l-1.229 2.129c-.116.2-.052.438.138.547l3.658 2.112-.455 2.735c-.109.657-.165 1.327-.165 2.01 0 .678.055 1.348.165 2.01l.455 2.735-3.658 2.112c-.186.107-.251.351-.138.547l1.229 2.129c.116.2.353.264.543.154l3.664-2.116 2.142 1.768c1.036.855 2.205 1.533 3.462 2l2.6.972v4.225c0 .215.179.393.405.393h2.458c.231 0 .405-.174.405-.393v-4.225l2.6-.972c1.257-.47 2.426-1.147 3.462-2l2.142-1.768 3.664 2.116c.186.107.43.042.543-.154l1.229-2.129c.116-.2.052-.438-.138-.547l-3.658-2.112.455-2.735c.109-.657.165-1.327.165-2.01 0-.678-.055-1.348-.165-2.01l-.455-2.735 3.658-2.112c.186-.107.251-.351.138-.547l-1.229-2.129c-.116-.2-.353-.264-.543-.154l-3.664 2.116-2.142-1.768c-1.036-.855-2.205-1.533-3.462-2l-2.6-.972v-4.225c0-.215-.179-.393-.405-.393h-2.458c-.231 0-.405.174-.405.393v4.225l-2.6.972c-1.257.47-2.426 1.147-3.462 2m2.062-5.749v-1.45c0-2.426 1.963-4.393 4.405-4.393h2.458c2.433 0 4.405 1.967 4.405 4.393v1.45c1.689.631 3.243 1.538 4.608 2.665l1.259-.727c2.101-1.213 4.786-.497 6.01 1.618l1.229 2.129c1.216 2.107.499 4.798-1.602 6.01l-1.257.726c.144.866.219 1.755.219 2.662 0 .907-.075 1.796-.219 2.662l1.257.726c2.101 1.213 2.823 3.896 1.602 6.01l-1.229 2.129c-1.216 2.107-3.906 2.832-6.01 1.618l-1.259-.727c-1.365 1.127-2.92 2.034-4.608 2.665v1.45c0 2.426-1.963 4.393-4.405 4.393h-2.458c-2.433 0-4.405-1.967-4.405-4.393v-1.45c-1.689-.631-3.243-1.538-4.608-2.665l-1.259.727c-2.101 1.213-4.786.497-6.01-1.618l-1.229-2.129c-1.216-2.107-.499-4.798 1.602-6.01l1.257-.726c-.144-.866-.219-1.755-.219-2.662 0-.907.075-1.796.219-2.662l-1.257-.726c-2.101-1.213-2.823-3.896-1.602-6.01l1.229-2.129c1.216-2.107 3.906-2.832 6.01-1.618l1.259.727c1.365-1.127 2.92-2.034 4.608-2.665\"/><path fill=\"#6b4fbb\" d=\"m20.12 23.366c1.347 0 2.439-1.092 2.439-2.439 0-1.347-1.092-2.439-2.439-2.439-1.347 0-2.439 1.092-2.439 2.439 0 1.347 1.092 2.439 2.439 2.439m0 4c-3.556 0-6.439-2.883-6.439-6.439 0-3.556 2.883-6.439 6.439-6.439 3.556 0 6.439 2.883 6.439 6.439 0 3.556-2.883 6.439-6.439 6.439\"/></g></g><use fill=\"#fff\" stroke=\"#e5e5e5\" stroke-width=\"8\" mask=\"url(#1)\" stroke-linejoin=\"round\" xlink:href=\"#0\"/><g transform=\"translate(175 58)\"><use fill=\"#fff\" stroke=\"#e5e5e5\" stroke-width=\"8\" mask=\"url(#3)\" xlink:href=\"#2\"/><g fill-rule=\"nonzero\"><path fill=\"#e5e5e5\" d=\"m41 78c20.435 0 37-16.565 37-37 0-20.435-16.565-37-37-37-20.435 0-37 16.565-37 37 0 20.435 16.565 37 37 37m0 4c-22.644 0-41-18.356-41-41 0-22.644 18.356-41 41-41 22.644 0 41 18.356 41 41 0 22.644-18.356 41-41 41\"/><g transform=\"matrix(.96593.25882-.25882.96593 23.581 9.415)\"><path fill=\"#b5a7dd\" d=\"m14.821 13.655l-2.142 1.768-3.933-2.271c-.72-.416-1.634-.171-2.046.543l-1.507 2.61c-.409.708-.161 1.631.553 2.043l3.926 2.267-.455 2.735c-.145.869-.218 1.754-.218 2.65 0 .896.073 1.782.218 2.65l.455 2.735-3.926 2.267c-.72.416-.965 1.329-.553 2.043l1.507 2.61c.409.708 1.332.955 2.046.543l3.933-2.271 2.142 1.768c1.369 1.131 2.916 2.027 4.579 2.648l2.6.972v4.534c0 .831.669 1.5 1.493 1.5h3.01c.817 0 1.493-.676 1.493-1.5v-4.534l2.6-.972c1.663-.621 3.21-1.518 4.579-2.648l2.142-1.768 3.933 2.271c.72.416 1.634.171 2.046-.543l1.507-2.61c.409-.708.161-1.631-.553-2.043l-3.926-2.267.455-2.735c.145-.869.218-1.754.218-2.65 0-.896-.073-1.782-.218-2.65l-.455-2.735 3.926-2.267c.72-.416.965-1.329.553-2.043l-1.507-2.61c-.409-.708-1.332-.955-2.046-.543l-3.933 2.271-2.142-1.768c-1.369-1.131-2.916-2.027-4.579-2.648l-2.6-.972v-4.534c0-.831-.669-1.5-1.493-1.5h-3.01c-.817 0-1.493.676-1.493 1.5v4.534l-2.6.972c-1.663.621-3.21 1.518-4.579 2.648m3.179-6.395v-1.759c0-3.038 2.471-5.5 5.493-5.5h3.01c3.034 0 5.493 2.46 5.493 5.5v1.759c2.098.784 4.03 1.91 5.725 3.311l1.528-.882c2.631-1.519 5.999-.61 7.51 2.01l1.507 2.61c1.517 2.627.616 5.987-2.02 7.507l-1.525.881c.179 1.076.272 2.18.272 3.307 0 1.127-.093 2.231-.272 3.307l1.525.881c2.631 1.519 3.528 4.89 2.02 7.507l-1.507 2.61c-1.517 2.627-4.877 3.527-7.51 2.01l-1.528-.882c-1.696 1.401-3.627 2.527-5.725 3.311v1.759c0 3.038-2.471 5.5-5.493 5.5h-3.01c-3.034 0-5.493-2.46-5.493-5.5v-1.759c-2.098-.784-4.03-1.91-5.725-3.311l-1.528.882c-2.631 1.519-5.999.61-7.51-2.01l-1.507-2.61c-1.517-2.627-.616-5.987 2.02-7.507l1.525-.881c-.179-1.076-.272-2.18-.272-3.307 0-1.127.093-2.231.272-3.307l-1.525-.881c-2.631-1.519-3.528-4.89-2.02-7.507l1.507-2.61c1.517-2.627 4.877-3.527 7.51-2.01l1.528.882c1.696-1.401 3.627-2.527 5.725-3.311\"/><path fill=\"#6b4fbb\" d=\"m25 30c2.209 0 4-1.791 4-4 0-2.209-1.791-4-4-4-2.209 0-4 1.791-4 4 0 2.209 1.791 4 4 4m0 4c-4.418 0-8-3.582-8-8 0-4.418 3.582-8 8-8 4.418 0 8 3.582 8 8 0 4.418-3.582 8-8 8\"/></g></g></g><g transform=\"translate(140 161)\"><path fill=\"#e5e5e5\" fill-rule=\"nonzero\" d=\"m4 8.541v30.01c0 2.202 1.793 3.995 4 3.995h20c2.209 0 4-1.789 4-3.995v-30.01c0-2.202-1.793-3.995-4-3.995h-20c-2.209 0-4 1.789-4 3.995m-4 0c0-4.416 3.583-7.995 8-7.995h20c4.416 0 8 3.584 8 7.995v30.01c0 4.416-3.583 7.995-8 7.995h-20c-4.416 0-8-3.584-8-7.995v-30.01\"/><g fill=\"#fb722e\"><rect width=\"4\" height=\"11\" x=\"10\" y=\"18.545\" rx=\"2\"/><rect width=\"4\" height=\"11\" x=\"21\" y=\"18.545\" rx=\"2\"/></g></g><path fill=\"#e5e5e5\" fill-rule=\"nonzero\" d=\"m445.16 245.34c-16.874-11.778-110.62-20.336-222.14-20.336-111.61 0-205.4 8.571-222.18 20.364-.904.635-1.121 1.883-.486 2.786.635.904 1.883 1.121 2.786.486 15.756-11.07 109.46-19.636 219.88-19.636 110.34 0 203.99 8.55 219.85 19.617.906.632 2.153.41 2.785-.495.632-.906.41-2.153-.495-2.785\"/></g></svg>"

/***/ }),

/***/ "../../views/shared/icons/_icon_commit.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 18\" enable-background=\"new 0 0 36 18\"><path d=\"m34 7h-7.2c-.9-4-4.5-7-8.8-7s-7.9 3-8.8 7h-7.2c-1.1 0-2 .9-2 2 0 1.1.9 2 2 2h7.2c.9 4 4.5 7 8.8 7s7.9-3 8.8-7h7.2c1.1 0 2-.9 2-2 0-1.1-.9-2-2-2m-16 7c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5\"/></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_play.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 11\" class=\"icon-play\"><path fill-rule=\"evenodd\" d=\"m9.283 6.47l-7.564 4.254c-.949.534-1.719.266-1.719-.576v-9.292c0-.852.756-1.117 1.719-.576l7.564 4.254c.949.534.963 1.392 0 1.934\"/></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_status_canceled.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z\"/><path d=\"M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z\" fill=\"#FFF\"/><path d=\"M5.2 3.8l4.9 4.9c.2.2.2.5 0 .7l-.7.7c-.2.2-.5.2-.7 0L3.8 5.2c-.2-.2-.2-.5 0-.7l.7-.7c.2-.2.5-.2.7 0\"/></g></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_status_canceled_borderless.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.17142857,5.97142857 L15.8714286,13.6714286 C16.1857143,13.9857143 16.1857143,14.4571429 15.8714286,14.7714286 L14.7714286,15.8714286 C14.4571429,16.1857143 13.9857143,16.1857143 13.6714286,15.8714286 L5.97142857,8.17142857 C5.65714286,7.85714286 5.65714286,7.38571429 5.97142857,7.07142857 L7.07142857,5.97142857 C7.38571429,5.65714286 7.85714286,5.65714286 8.17142857,5.97142857\" id=\"Shape\"></path></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_status_created.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z\"/><path d=\"M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z\" fill=\"#FFF\"/><circle cx=\"7\" cy=\"7\" r=\"3.25\"/></g></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_status_created_borderless.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><circle id=\"Oval\" cx=\"11\" cy=\"11\" r=\"5.10714286\"></circle></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_status_failed.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z\"/><path d=\"M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z\" fill=\"#FFF\"/><path d=\"M7 5.969L5.599 4.568a.29.29 0 0 0-.413.004l-.614.614a.294.294 0 0 0-.004.413L5.968 7l-1.4 1.401a.29.29 0 0 0 .004.413l.614.614c.113.114.3.117.413.004L7 8.032l1.401 1.4a.29.29 0 0 0 .413-.004l.614-.614a.294.294 0 0 0 .004-.413L8.032 7l1.4-1.401a.29.29 0 0 0-.004-.413l-.614-.614a.294.294 0 0 0-.413-.004L7 5.968z\"/></g></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_status_failed_borderless.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.1458333,9.85416667 L12.1458333,6.74047388 C12.1458333,6.4826434 11.9382041,6.28571429 11.6820804,6.28571429 L10.3179196,6.28571429 C10.0656535,6.28571429 9.85416667,6.48931709 9.85416667,6.74047388 L9.85416667,9.85416667 L6.74047388,9.85416667 C6.4826434,9.85416667 6.28571429,10.0617959 6.28571429,10.3179196 L6.28571429,11.6820804 C6.28571429,11.9343465 6.48931709,12.1458333 6.74047388,12.1458333 L9.85416667,12.1458333 L9.85416667,15.2595261 C9.85416667,15.5173566 10.0617959,15.7142857 10.3179196,15.7142857 L11.6820804,15.7142857 C11.9343465,15.7142857 12.1458333,15.5106829 12.1458333,15.2595261 L12.1458333,12.1458333 L15.2595261,12.1458333 C15.5173566,12.1458333 15.7142857,11.9382041 15.7142857,11.6820804 L15.7142857,10.3179196 C15.7142857,10.0656535 15.5106829,9.85416667 15.2595261,9.85416667 L12.1458333,9.85416667 Z\" id=\"Combined-Shape\" transform=\"translate(11.000000, 11.000000) rotate(-45.000000) translate(-11.000000, -11.000000) \"></path></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_status_manual.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z\"/><path d=\"M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z\" fill=\"#FFF\"/><path d=\"M10.5 7.63V6.37l-.787-.13c-.044-.175-.132-.349-.263-.61l.481-.652-.918-.913-.657.478a2.346 2.346 0 0 0-.612-.26L7.656 3.5H6.388l-.132.783c-.219.043-.394.13-.612.26l-.657-.478-.918.913.437.652c-.131.218-.175.392-.262.61l-.744.086v1.261l.787.13c.044.218.132.392.263.61l-.438.651.92.913.655-.434c.175.086.394.173.613.26l.131.783h1.313l.131-.783c.219-.043.394-.13.613-.26l.656.478.918-.913-.48-.652c.13-.218.218-.435.262-.61l.656-.13zM7 8.283a1.285 1.285 0 0 1-1.313-1.305c0-.739.57-1.304 1.313-1.304.744 0 1.313.565 1.313 1.304 0 .74-.57 1.305-1.313 1.305z\"/></g></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_status_manual_borderless.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16.5,11.9906832 L16.5,10.0093168 L15.2625,9.80434783 C15.19375,9.5310559 15.05625,9.25776398 14.85,8.84782609 L15.60625,7.82298137 L14.1625,6.38819876 L13.13125,7.13975155 C12.7875,6.93478261 12.44375,6.79813665 12.16875,6.72981366 L12.03125,5.5 L10.0375,5.5 L9.83125,6.72981366 C9.4875,6.79813665 9.2125,6.93478261 8.86875,7.13975155 L7.8375,6.38819876 L6.39375,7.82298137 L7.08125,8.84782609 C6.875,9.18944099 6.80625,9.46273292 6.66875,9.80434783 L5.5,9.94099379 L5.5,11.9223602 L6.7375,12.1273292 C6.80625,12.4689441 6.94375,12.742236 7.15,13.0838509 L6.4625,14.1086957 L7.90625,15.5434783 L8.9375,14.8602484 C9.2125,14.9968944 9.55625,15.1335404 9.9,15.2701863 L10.10625,16.5 L12.16875,16.5 L12.375,15.2701863 C12.71875,15.2018634 12.99375,15.0652174 13.3375,14.8602484 L14.36875,15.6118012 L15.8125,14.1770186 L15.05625,13.1521739 C15.2625,12.810559 15.4,12.4689441 15.46875,12.1956522 L16.5,11.9906832 L16.5,11.9906832 Z M11,13.015528 C9.83125,13.015528 8.9375,12.1273292 8.9375,10.9658385 C8.9375,9.80434783 9.83125,8.91614907 11,8.91614907 C12.16875,8.91614907 13.0625,9.80434783 13.0625,10.9658385 C13.0625,12.1273292 12.16875,13.015528 11,13.015528 L11,13.015528 Z\" id=\"Shape\" ></path></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_status_pending.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z\"/><path d=\"M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z\" fill=\"#FFF\"/><path d=\"M4.7 5.3c0-.2.1-.3.3-.3h.9c.2 0 .3.1.3.3v3.4c0 .2-.1.3-.3.3H5c-.2 0-.3-.1-.3-.3V5.3m3 0c0-.2.1-.3.3-.3h.9c.2 0 .3.1.3.3v3.4c0 .2-.1.3-.3.3H8c-.2 0-.3-.1-.3-.3V5.3\"/></g></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_status_pending_borderless.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.38571429,8.32857143 C7.38571429,8.01428571 7.54285714,7.85714286 7.85714286,7.85714286 L9.27142857,7.85714286 C9.58571429,7.85714286 9.74285714,8.01428571 9.74285714,8.32857143 L9.74285714,13.6714286 C9.74285714,13.9857143 9.58571429,14.1428571 9.27142857,14.1428571 L7.85714286,14.1428571 C7.54285714,14.1428571 7.38571429,13.9857143 7.38571429,13.6714286 L7.38571429,8.32857143 M12.1,8.32857143 C12.1,8.01428571 12.2571429,7.85714286 12.5714286,7.85714286 L13.9857143,7.85714286 C14.3,7.85714286 14.4571429,8.01428571 14.4571429,8.32857143 L14.4571429,13.6714286 C14.4571429,13.9857143 14.3,14.1428571 13.9857143,14.1428571 L12.5714286,14.1428571 C12.2571429,14.1428571 12.1,13.9857143 12.1,13.6714286 L12.1,8.32857143\" id=\"Shape\"></path></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_status_running.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z\"/><path d=\"M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z\" fill=\"#FFF\"/><path d=\"M7 3c2.2 0 4 1.8 4 4s-1.8 4-4 4c-1.3 0-2.5-.7-3.3-1.7L7 7V3\"/></g></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_status_running_borderless.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11,4.71428571 C14.4571429,4.71428571 17.2857143,7.54285714 17.2857143,11 C17.2857143,14.4571429 14.4571429,17.2857143 11,17.2857143 C8.95714286,17.2857143 7.07142857,16.1857143 5.81428571,14.6142857 L11,11 L11,4.71428571\" id=\"Shape\"></path></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_status_skipped.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 14A7 7 0 1 1 7 0a7 7 0 0 1 0 14z\"/><path d=\"M7 13A6 6 0 1 0 7 1a6 6 0 0 0 0 12z\" fill=\"#FFF\" fill-rule=\"nonzero\"/><path d=\"M6.415 7.04L4.579 5.203a.295.295 0 0 1 .004-.416l.349-.349a.29.29 0 0 1 .416-.004l2.214 2.214a.289.289 0 0 1 .019.021l.132.133c.11.11.108.291 0 .398L5.341 9.573a.282.282 0 0 1-.398 0l-.331-.331a.285.285 0 0 1 0-.399L6.415 7.04zm2.54 0L7.119 5.203a.295.295 0 0 1 .004-.416l.349-.349a.29.29 0 0 1 .416-.004l2.214 2.214a.289.289 0 0 1 .019.021l.132.133c.11.11.108.291 0 .398L7.881 9.573a.282.282 0 0 1-.398 0l-.331-.331a.285.285 0 0 1 0-.399L8.955 7.04z\"/></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_status_skipped_borderless.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"22\" height=\"22\" viewBox=\"0 0 22 22\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.072 11.063l-2.82 2.82a.46.46 0 0 0-.001.652l.495.495a.457.457 0 0 0 .653-.001l3.7-3.7a.46.46 0 0 0 .001-.653l-.196-.196a.453.453 0 0 0-.03-.033l-3.479-3.479a.464.464 0 0 0-.654.007l-.548.548a.463.463 0 0 0-.007.654l2.886 2.886z\"/><path d=\"M10.08 11.063l-2.819 2.82a.46.46 0 0 0-.002.652l.496.495a.457.457 0 0 0 .652-.001l3.7-3.7a.46.46 0 0 0 .002-.653l-.196-.196a.453.453 0 0 0-.03-.033l-3.48-3.479a.464.464 0 0 0-.653.007l-.548.548a.463.463 0 0 0-.007.654l2.886 2.886z\"/></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_status_success.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z\"/><path d=\"M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z\" fill=\"#FFF\"/><path d=\"M6.278 7.697L5.045 6.464a.296.296 0 0 0-.42-.002l-.613.614a.298.298 0 0 0 .002.42l1.91 1.909a.5.5 0 0 0 .703.005l.265-.265L9.997 6.04a.291.291 0 0 0-.009-.408l-.614-.614a.29.29 0 0 0-.408-.009L6.278 7.697z\"/></g></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_status_success_borderless.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.4583333,12.375 L8.70008808,12.375 C8.45889044,12.375 8.25,12.5826293 8.25,12.8387529 L8.25,14.2029137 C8.25,14.4551799 8.4515113,14.6666667 8.70008808,14.6666667 L12.9619841,14.6666667 C13.3891296,14.6666667 13.75,14.3193051 13.75,13.8908129 L13.75,13.2899463 L13.75,6.42552703 C13.75,6.16226705 13.5423707,5.95833333 13.2862471,5.95833333 L11.9220863,5.95833333 C11.6698201,5.95833333 11.4583333,6.16750307 11.4583333,6.42552703 L11.4583333,12.375 Z\" id=\"Combined-Shape\" transform=\"translate(11.000000, 10.312500) rotate(-315.000000) translate(-11.000000, -10.312500) \"></path></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_status_warning.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z\"/><path d=\"M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z\" fill=\"#FFF\"/><path d=\"M6 3.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v4c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-4m0 6c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-1\"/></g></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_status_warning_borderless.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9.42857143,5.5 C9.42857143,5.02857143 9.74285714,4.71428571 10.2142857,4.71428571 L11.7857143,4.71428571 C12.2571429,4.71428571 12.5714286,5.02857143 12.5714286,5.5 L12.5714286,11.7857143 C12.5714286,12.2571429 12.2571429,12.5714286 11.7857143,12.5714286 L10.2142857,12.5714286 C9.74285714,12.5714286 9.42857143,12.2571429 9.42857143,11.7857143 L9.42857143,5.5 M9.42857143,14.9285714 C9.42857143,14.4571429 9.74285714,14.1428571 10.2142857,14.1428571 L11.7857143,14.1428571 C12.2571429,14.1428571 12.5714286,14.4571429 12.5714286,14.9285714 L12.5714286,16.5 C12.5714286,16.9714286 12.2571429,17.2857143 11.7857143,17.2857143 L10.2142857,17.2857143 C9.74285714,17.2857143 9.42857143,16.9714286 9.42857143,16.5 L9.42857143,14.9285714\" id=\"Shape\"></path></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_timer.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"40\" viewBox=\"0 0 40 40\"><g fill=\"#8F8F8F\" fill-rule=\"evenodd\"><path d=\"M29.513 10.134A15.922 15.922 0 0 0 23 7.28V6h2.993C26.55 6 27 5.552 27 5V2a1 1 0 0 0-1.007-1H14.007C13.45 1 13 1.448 13 2v3a1 1 0 0 0 1.007 1H17v1.28C9.597 8.686 4 15.19 4 23c0 8.837 7.163 16 16 16s16-7.163 16-16c0-3.461-1.099-6.665-2.967-9.283l1.327-1.58a2.498 2.498 0 0 0-.303-3.53 2.499 2.499 0 0 0-3.528.315l-1.016 1.212zM20 34c6.075 0 11-4.925 11-11s-4.925-11-11-11S9 16.925 9 23s4.925 11 11 11z\"/><path d=\"M19 21h-4.002c-.552 0-.998.452-.998 1.01v1.98c0 .567.447 1.01.998 1.01h7.004c.274 0 .521-.111.701-.291a.979.979 0 0 0 .297-.704v-8.01c0-.54-.452-.995-1.01-.995h-1.98a.997.997 0 0 0-1.01.995V21z\"/></g></svg>\n"

/***/ }),

/***/ "../images/no_avatar.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAAAAAAdJSU2AAACNElEQVR4AdXYBa7jMBCA4b3/JZahzIkjp2qt+BWUWnG5ln2XxaJJb2b5F2ukL4wvzK/rP7bUcbf92u6oftLSe1ldk8efsfaVeEjusZZeC6e1RllaCk/yG6ag1lZ4WwPX69uyD6tAe/g2ipAlNMRS37awDLaFrpcMWxXQOi0jnWCWjFkSZomYJWDWKmatYNZyEWkJsvQimoZYah5NgdaLxagCtF6GRy0DshZPkeYwS/KIJWGWYjwYUzDLxCwDtJ54OKglimBLqHWahii2g1pmHLLGBmwVoRjcKlmgOdw65H5qKuGWCVi5Qlhs6m1sENZi4q3AWNvca5UYy2RjT/SAsiZey6CsIvc0wVlV5lJ0ibPMyLUGCmlxQq0IM0hLdWyro7CWEc3sXsqaK4O2zLxOsmtpfW5Q1u68ZrVmepaaNXEewawtI9X5Xl3U3n1qND6+rfPzvqoIWz/fklNCSLY153YV53J/XUxGCJnKZ1lajsn3/Ffegf6Y5pV2LUsSNL2UHzxUfh3TlYpZqqTpXZm0KZk9zJcqaEmaWPHDw0pxe05K7bWOLHFLWXVetqpYmrjle4+1y0aBaF4UOQ1NU+lYezJClkjLUnSEjqhH6zjAW4OjtY39Ibq+sawUb6W2RQfoqG0VeKuwrRJvlba17faRdbe2pTtYq6Nty/S7yAbGsQjWIq41wVoT1+IdZNy1djUcVdu5lklQWC0xHkt1X31qNEE1Pr3qKv/9XiSNj6Aaifj3/69+AYujsR/MvkpZAAAAAElFTkSuQmCC"

/***/ }),

/***/ "./lib/utils/http_status.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * exports HTTP status codes
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  NO_CONTENT: 204,
  OK: 200
});

/***/ }),

/***/ "./lib/utils/poll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_status__ = __webpack_require__("./lib/utils/http_status.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * Polling utility for handling realtime updates.
 * Service for vue resouce and method need to be provided as props
 *
 * @example
 * new Poll({
 *   resource: resource,
 *   method: 'name',
 *   data: {page: 1, scope: 'all'}, // optional
 *   successCallback: () => {},
 *   errorCallback: () => {},
 *   notificationCallback: () => {}, // optional
 * }).makeRequest();
 *
 * Usage in pipelines table with visibility lib:
 *
 * const poll = new Poll({
 *  resource: this.service,
 *  method: 'getPipelines',
 *  data: { page: pageNumber, scope },
 *  successCallback: this.successCallback,
 *  errorCallback: this.errorCallback,
 *  notificationCallback: this.updateLoading,
 * });
 *
 * if (!Visibility.hidden()) {
 *  poll.makeRequest();
 *  }
 *
 * Visibility.change(() => {
 *  if (!Visibility.hidden()) {
 *   poll.restart();
 *  } else {
 *   poll.stop();
 *  }
* });
 *
 * 1. Checks for response and headers before start polling
 * 2. Interval is provided by `Poll-Interval` header.
 * 3. If `Poll-Interval` is -1, we stop polling
 * 4. If HTTP response is 200, we poll.
 * 5. If HTTP response is different from 200, we stop polling.
 *
 */

var Poll = function () {
  function Poll() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Poll);

    this.options = options;
    this.options.data = options.data || {};
    this.options.notificationCallback = options.notificationCallback || function notificationCallback() {};

    this.intervalHeader = 'POLL-INTERVAL';
    this.timeoutID = null;
    this.canPoll = true;
  }

  _createClass(Poll, [{
    key: 'checkConditions',
    value: function checkConditions(response) {
      var _this = this;

      var headers = gl.utils.normalizeHeaders(response.headers);
      var pollInterval = parseInt(headers[this.intervalHeader], 10);

      if (pollInterval > 0 && response.status === __WEBPACK_IMPORTED_MODULE_0__http_status__["a" /* default */].OK && this.canPoll) {
        this.timeoutID = setTimeout(function () {
          _this.makeRequest();
        }, pollInterval);
      }
      this.options.successCallback(response);
    }
  }, {
    key: 'makeRequest',
    value: function makeRequest() {
      var _this2 = this;

      var _options = this.options,
          resource = _options.resource,
          method = _options.method,
          data = _options.data,
          errorCallback = _options.errorCallback,
          notificationCallback = _options.notificationCallback;

      // It's called everytime a new request is made. Useful to update the status.

      notificationCallback(true);

      return resource[method](data).then(function (response) {
        _this2.checkConditions(response);
        notificationCallback(false);
      }).catch(function (error) {
        notificationCallback(false);
        errorCallback(error);
      });
    }

    /**
     * Stops the polling recursive chain
     * and guarantees if the timeout is already running it won't make another request by
     * cancelling the previously established timeout.
     */

  }, {
    key: 'stop',
    value: function stop() {
      this.canPoll = false;
      clearTimeout(this.timeoutID);
    }

    /**
     * Restarts polling after it has been stoped
     */

  }, {
    key: 'restart',
    value: function restart() {
      this.canPoll = true;
      this.makeRequest();
    }
  }]);

  return Poll;
}();

/* harmony default export */ __webpack_exports__["a"] = (Poll);

/***/ }),

/***/ "./pipelines/components/async_button.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/async_button.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-06d5852e\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/async_button.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./pipelines/components/empty_state.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/empty_state.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-492e488a\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/empty_state.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./pipelines/components/error_state.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/error_state.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-2dea8a94\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/error_state.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./pipelines/components/nav_controls.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/nav_controls.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-5eb08234\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/nav_controls.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./pipelines/components/navigation_tabs.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/navigation_tabs.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-2528e465\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/navigation_tabs.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./pipelines/components/pipeline_url.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipeline_url.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-57efd6e6\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipeline_url.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./pipelines/components/pipelines.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-5cb4e2a6\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./pipelines/components/pipelines_actions.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_actions.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-d246eb2a\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_actions.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./pipelines/components/pipelines_artifacts.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_artifacts.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-713a66cf\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_artifacts.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./pipelines/components/pipelines_table.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_table.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-51860a3c\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_table.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./pipelines/components/pipelines_table_row.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_table_row.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-97d30852\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_table_row.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./pipelines/components/stage.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/stage.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-3f0b4b1a\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/stage.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./pipelines/components/time_ago.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/time_ago.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-709158ab\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/time_ago.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./pipelines/event_hub.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]());

/***/ }),

/***/ "./pipelines/mixins/pipelines.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__flash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_visibilityjs__ = __webpack_require__("../../../node_modules/visibilityjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_visibilityjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_visibilityjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_poll__ = __webpack_require__("./lib/utils/poll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_empty_state_vue__ = __webpack_require__("./pipelines/components/empty_state.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_empty_state_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_empty_state_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_error_state_vue__ = __webpack_require__("./pipelines/components/error_state.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_error_state_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_error_state_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_shared_components_loading_icon_vue__ = __webpack_require__("./vue_shared/components/loading_icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_shared_components_loading_icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__vue_shared_components_loading_icon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pipelines_table_vue__ = __webpack_require__("./pipelines/components/pipelines_table.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pipelines_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pipelines_table_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__event_hub__ = __webpack_require__("./pipelines/event_hub.js");
/* global Flash */









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pipelinesTableComponent: __WEBPACK_IMPORTED_MODULE_6__components_pipelines_table_vue___default.a,
    errorState: __WEBPACK_IMPORTED_MODULE_4__components_error_state_vue___default.a,
    emptyState: __WEBPACK_IMPORTED_MODULE_3__components_empty_state_vue___default.a,
    loadingIcon: __WEBPACK_IMPORTED_MODULE_5__vue_shared_components_loading_icon_vue___default.a
  },
  computed: {
    shouldRenderErrorState: function shouldRenderErrorState() {
      return this.hasError && !this.isLoading;
    }
  },
  data: function data() {
    return {
      isLoading: false,
      hasError: false,
      isMakingRequest: false,
      updateGraphDropdown: false,
      hasMadeRequest: false
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.poll = new __WEBPACK_IMPORTED_MODULE_2__lib_utils_poll__["a" /* default */]({
      resource: this.service,
      method: 'getPipelines',
      data: this.requestData ? this.requestData : undefined,
      successCallback: this.successCallback,
      errorCallback: this.errorCallback,
      notificationCallback: this.setIsMakingRequest
    });

    if (!__WEBPACK_IMPORTED_MODULE_1_visibilityjs___default.a.hidden()) {
      this.isLoading = true;
      this.poll.makeRequest();
    } else {
      // If tab is not visible we need to make the first request so we don't show the empty
      // state without knowing if there are any pipelines
      this.fetchPipelines();
    }

    __WEBPACK_IMPORTED_MODULE_1_visibilityjs___default.a.change(function () {
      if (!__WEBPACK_IMPORTED_MODULE_1_visibilityjs___default.a.hidden()) {
        _this.poll.restart();
      } else {
        _this.poll.stop();
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__event_hub__["a" /* default */].$on('refreshPipelines', this.fetchPipelines);
    __WEBPACK_IMPORTED_MODULE_7__event_hub__["a" /* default */].$on('postAction', this.postAction);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_7__event_hub__["a" /* default */].$off('refreshPipelines');
    __WEBPACK_IMPORTED_MODULE_7__event_hub__["a" /* default */].$on('postAction', this.postAction);
  },
  destroyed: function destroyed() {
    this.poll.stop();
  },

  methods: {
    fetchPipelines: function fetchPipelines() {
      var _this2 = this;

      if (!this.isMakingRequest) {
        this.isLoading = true;

        this.service.getPipelines(this.requestData).then(function (response) {
          return _this2.successCallback(response);
        }).catch(function () {
          return _this2.errorCallback();
        });
      }
    },
    setCommonData: function setCommonData(pipelines) {
      this.store.storePipelines(pipelines);
      this.isLoading = false;
      this.updateGraphDropdown = true;
      this.hasMadeRequest = true;
    },
    errorCallback: function errorCallback() {
      this.hasError = true;
      this.isLoading = false;
      this.updateGraphDropdown = false;
    },
    setIsMakingRequest: function setIsMakingRequest(isMakingRequest) {
      this.isMakingRequest = isMakingRequest;

      if (isMakingRequest) {
        this.updateGraphDropdown = false;
      }
    },
    postAction: function postAction(endpoint) {
      this.service.postAction(endpoint).then(function () {
        return __WEBPACK_IMPORTED_MODULE_7__event_hub__["a" /* default */].$emit('refreshPipelines');
      }).catch(function () {
        return new Flash('An error occured while making the request.');
      });
    }
  }
});

/***/ }),

/***/ "./pipelines/pipelines_bundle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stores_pipelines_store__ = __webpack_require__("./pipelines/stores/pipelines_store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pipelines_vue__ = __webpack_require__("./pipelines/components/pipelines.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pipelines_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_pipelines_vue__);




document.addEventListener('DOMContentLoaded', function () {
  return new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#pipelines-list-vue',
    data: function data() {
      var store = new __WEBPACK_IMPORTED_MODULE_1__stores_pipelines_store__["a" /* default */]();

      return {
        store: store
      };
    },

    components: {
      pipelinesComponent: __WEBPACK_IMPORTED_MODULE_2__components_pipelines_vue___default.a
    },
    render: function render(createElement) {
      return createElement('pipelines-component', {
        props: {
          store: this.store
        }
      });
    }
  });
});

/***/ }),

/***/ "./pipelines/services/pipelines_service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("../../../node_modules/vue-resource/dist/vue-resource.common.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_resource__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource___default.a);

var PipelinesService = function () {

  /**
  * Commits and merge request endpoints need to be requested with `.json`.
  *
  * The url provided to request the pipelines in the new merge request
  * page already has `.json`.
  *
  * @param  {String} root
  */
  function PipelinesService(root) {
    _classCallCheck(this, PipelinesService);

    var endpoint = void 0;

    if (root.indexOf('.json') === -1) {
      endpoint = root + '.json';
    } else {
      endpoint = root;
    }

    this.pipelines = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].resource(endpoint);
  }

  _createClass(PipelinesService, [{
    key: 'getPipelines',
    value: function getPipelines() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var scope = data.scope,
          page = data.page;

      return this.pipelines.get({ scope: scope, page: page });
    }

    /**
     * Post request for all pipelines actions.
     *
     * @param  {String} endpoint
     * @return {Promise}
     */

  }, {
    key: 'postAction',
    value: function postAction(endpoint) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(endpoint + '.json');
    }
  }]);

  return PipelinesService;
}();

/* harmony default export */ __webpack_exports__["a"] = (PipelinesService);

/***/ }),

/***/ "./pipelines/stores/pipelines_store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PipelinesStore = function () {
  function PipelinesStore() {
    _classCallCheck(this, PipelinesStore);

    this.state = {};

    this.state.pipelines = [];
    this.state.count = {};
    this.state.pageInfo = {};
  }

  _createClass(PipelinesStore, [{
    key: "storePipelines",
    value: function storePipelines() {
      var pipelines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.state.pipelines = pipelines;
    }
  }, {
    key: "storeCount",
    value: function storeCount() {
      var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.state.count = count;
    }
  }, {
    key: "storePagination",
    value: function storePagination() {
      var pagination = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var paginationInfo = void 0;

      if (Object.keys(pagination).length) {
        var normalizedHeaders = gl.utils.normalizeHeaders(pagination);
        paginationInfo = gl.utils.parseIntPagination(normalizedHeaders);
      } else {
        paginationInfo = pagination;
      }

      this.state.pageInfo = paginationInfo;
    }
  }]);

  return PipelinesStore;
}();

/* harmony default export */ __webpack_exports__["a"] = (PipelinesStore);

/***/ })

},["./pipelines/pipelines_bundle.js"]);


// WEBPACK FOOTER //
// pipelines.6041b578afd2bdb757f2.bundle.js